// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.button-align[data-v-3e87b2d8] {\n  border: 1px solid transparent;\n  border-radius: 5px;\n  background-color: #fff;\n  font-size: 14px;\n  margin-right: 3px;\n}\n.button-align[data-v-3e87b2d8]:hover,\n.button-align[data-v-3e87b2d8]:focus {\n  color: #0d4711;\n  background-color: #fff;\n  border-color: #0d4711;\n}\n.button-file[data-v-3e87b2d8] {\n  margin-left: 5px;\n  margin-left: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
